var map = {
	"./IMG_4727.jpeg": 5646,
	"./bossforest.png": 340,
	"./klear_logo.png": 8062,
	"./profile.jpeg": 7389,
	"./qrency.png": 3421,
	"./shirley_huang.png": 3050,
	"./shopify.webp": 1662,
	"./simonsays.jpeg": 3195,
	"./svg/github.svg": 2,
	"./svg/linkedin.svg": 463,
	"./travel/bali1.jpeg": 2281,
	"./travel/bali2.jpeg": 4291,
	"./travel/bali3.jpg": 7413,
	"./travel/singapore1.jpeg": 6900,
	"./travel/singapore2.jpeg": 4251,
	"./travel/singapore3.jpeg": 4069,
	"./travel/sk1.jpeg": 9617,
	"./travel/sk2.jpeg": 2989,
	"./travel/sk3.jpeg": 1455,
	"./travel/thailand1.jpeg": 1851,
	"./travel/thailand2.jpeg": 4885,
	"./travel/thailand3.jpeg": 710,
	"./travel/thailand4.jpeg": 5886,
	"./travel/thailand5.jpeg": 6220,
	"./travel/thailand6.jpeg": 8220,
	"./travel/vietnam1.jpeg": 1243,
	"./travel/vietnam2.jpeg": 5703,
	"./travel/vietnam3.jpeg": 2394,
	"./travel/vietnam4.jpeg": 4702,
	"./travel/vietnam5.jpeg": 1870
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7173;